import React from "react";
import {
  displayTransferRecipient,
  displayTransferStatus,
} from "../../utils/utils";

const TERMINAL_NEGATIVE = ["FAILED", "DECLINED", "CANCELLED", "EXPIRED"];

const arrowDown = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="12" y1="4" x2="12" y2="18" />
    <polyline points="6 12 12 18 18 12" />
  </svg>
);

const arrowUp = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="12" y1="20" x2="12" y2="6" />
    <polyline points="6 12 12 6 18 12" />
  </svg>
);

const dash = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <line x1="6" y1="12" x2="18" y2="12" />
  </svg>
);

const IncomingTransfer = ({ incoming, handleLinkClick }) => {
  const isRequestForPay = incoming.originated_as_rfp === true;
  // Incoming RfP = the viewer is the REQUESTEE. Money flowed AWAY from them
  // when they paid — show "-$X" so it reads like a debit.
  // Once it's a money movement (Succeeded/Failed) we know money moved; for
  // anything earlier the row wouldn't be in history at all.
  const isRfpDebit = isRequestForPay && incoming.status === "SUCCEEDED";
  const isTerminalNegative = TERMINAL_NEGATIVE.includes(incoming.status);
  const amountPrefix = isRfpDebit ? "-" : isRequestForPay ? "" : "+";
  const partyLabel = isRequestForPay
    ? incoming.sender_identifier || incoming.sender_name || "Someone"
    : displayTransferRecipient(incoming.recipient, true, incoming);

  const avatar = () => {
    if (isTerminalNegative) {
      return <span className="np-avatar np-avatar-muted">{dash}</span>;
    }
    if (isRfpDebit) {
      return <span className="np-avatar np-avatar-accent">{arrowUp}</span>;
    }
    return <span className="np-avatar">{arrowDown}</span>;
  };

  return (
    <li className="np-list-row" onClick={(event) => handleLinkClick(event)}>
      {avatar()}
      <div className="np-list-body">
        <div className="np-list-title">{partyLabel}</div>
        <div className="np-list-sub">{displayTransferStatus(incoming)}</div>
      </div>
      <div
        className={
          isTerminalNegative
            ? "np-list-amount np-list-amount-muted"
            : "np-list-amount"
        }
      >
        {amountPrefix}${incoming.amount.value}
      </div>
    </li>
  );
};

export default IncomingTransfer;
